import { TranslateService } from "@ngx-translate/core";
import { AccountService } from "./account.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { CompanyList } from "../models/company-list";
import { Account } from "../screens/user-profile/client-data";
import { UrlConstants } from "../models/urlConstants";
import { ToastrService } from "ngx-toastr";
import { map, tap } from "rxjs/operators";
import { log } from "node:console";
@Injectable({
  providedIn: "root",
})
export class FavService {
  favCompanies: BehaviorSubject<CompanyList[]> = new BehaviorSubject<CompanyList[]>([]);
  favCompaniesSymbols: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  marketWatches: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  activeMarketWatch: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  selectedMarketWatchId:number =0;
  accList : Account[] = [];
  AllMarketWatchesCount: number = 0;

  constructor(
    private accService: AccountService,
    private http: HttpClient,
    private toastr: ToastrService,
    private _translate: TranslateService
  ) {
  }


isFav(symbol: string, marketWatchId?: number): boolean {
  let favCodes = this.favCompaniesSymbols.getValue();
  
  // Handle empty/null state
  if (!favCodes) {
    return false;
  }
  
  // Your existing logic here
  return favCodes.includes(symbol);
}
removeFav(symbol: string, marketWatchId?: number) {
  let favCodes = this.favCompaniesSymbols.getValue();
  
  if (!favCodes) {
    return; // Nothing to remove
  }
  
  const index = favCodes.indexOf(symbol);
  if (index > -1) {
    favCodes.splice(index, 1);
    this.favCompaniesSymbols.next(favCodes);
    
    // Make sure to update the backend when removing
    this.updateFavs(favCodes, marketWatchId, 
      marketWatchId ? `Market Watch ${marketWatchId}` : "Default Favorite", 
      false);
  }
}

  deleteMarketWatch(marketWatchID: string): Observable<any> {
    // if(this.AllMarketWatchesCount <= 1) {
    //   this.toastr.warning(
    //     this._translate.instant("cannot-delete-last-watch"),
    //     this._translate.instant("delete-watch-title"),
    //     {
    //       positionClass: "toast-bottom-right",
    //       closeButton: false,
    //       titleClass: "toast-error-title",
    //       messageClass: "toast-error-message",
    //     }
    //   );
    //   return new Observable<any>();

    // }
    return this.http.post<any>(UrlConstants.backofficeUrl+ `/api/Client/RemoveMarketWatchByID?marketWatchID=${marketWatchID}`,{});
  }


toggleFav(symbol: string, marketWatchId: number) {
  // Input validation
  if (!symbol || symbol.trim() === '') {
    return;
  }

  if (marketWatchId == null || marketWatchId == undefined || marketWatchId == 0) {
    // Case 1: Default favorites (no specific market watch)
    let favCodes = this.favCompaniesSymbols.getValue();
    
    // Handle null/undefined favCodes (empty state)
    if (!favCodes) {
      favCodes = [];
    }
    
    if (this.isFav(symbol)) {
      // Remove from default favorites
      this.removeFav(symbol, marketWatchId);
    } else {
      // Add to default favorites (check for duplicates)
      if (!favCodes.includes(symbol)) {
        favCodes.push(symbol);
        this.favCompaniesSymbols.next(favCodes);
        this.updateFavs(favCodes, marketWatchId, "Default Favorite", false);
      }
    }
  } else {
    // Case 2: Specific market watch favorites
    let favCodes = this.favCompaniesSymbols.getValue();
    
    // Handle null/undefined favCodes (empty state after last symbol removal)
    if (!favCodes) {
      favCodes = [];
    }
    
    if (this.isFav(symbol, marketWatchId)) {
      // Remove from market watch favorites
      this.removeFav(symbol, marketWatchId);
    } else {
      // Add to market watch favorites
      // For empty market watch, always add the symbol
      if (!favCodes.includes(symbol)) {
        favCodes.push(symbol);
        this.favCompaniesSymbols.next(favCodes);
        this.updateFavs(favCodes, marketWatchId, `Market Watch ${marketWatchId}`, false);
      }
    }
  }
}
 updateFavs(symbols: string[], marketWatchId: number, marketWatchName: string, defaultList: boolean): void {
  // Get account list with error handling
  const accListStr = localStorage.getItem("accList");
  if (!accListStr) {
    this.toastr.error(
      this._translate.instant("account-not-found"),
      this._translate.instant("error"),
      {
        positionClass: "toast-bottom-right",
        closeButton: false,
        titleClass: "toast-error-title",
        messageClass: "toast-error-message",
      }
    );
    return;
  }

  try {
    this.accList = JSON.parse(accListStr) as Account[];
  } catch (error) {
    this.toastr.error(
      this._translate.instant("account-not-found"),
      this._translate.instant("error"),
      {
        positionClass: "toast-bottom-right",
        closeButton: false,
        titleClass: "toast-error-title",
        messageClass: "toast-error-message",
      }
    );
    return;
  }

  const relationCode = this.accList?.[0]?.relationCode ?? '';
  if (!relationCode) {
    this.toastr.error(
      this._translate.instant("account-not-found"),
      this._translate.instant("error"),
      {
        positionClass: "toast-bottom-right",
        closeButton: false,
        titleClass: "toast-error-title",
        messageClass: "toast-error-message",
      }
    );
    return;
  }

  // Use the parameter value directly, fall back to active market watch if needed
  const finalMarketWatchId = marketWatchId ?? this.activeMarketWatch.getValue()?.MarketWatchID ;
  this.selectedMarketWatchId = finalMarketWatchId;

  let currentFavsBackup: string[] = [];
  // Store current state for potential rollback
  if(finalMarketWatchId !== 0) {
    
    const currentFavs = this.favCompaniesSymbols.getValue() ?? [];
    currentFavsBackup = [...currentFavs]; // Create a proper copy
  }
  

  const requestPayload = {
    RelationCode: relationCode,
    Symbols: symbols,
    MarketWatchID: finalMarketWatchId,
    MarketWatchName: marketWatchName,
    IsDefault: defaultList
  };

  this.http
    .post(UrlConstants.backofficeUrl + "/api/Client/PostClientMarketWatchNew", requestPayload)
    .subscribe({
      next: (res) => {
        if (res) {
          this.fetchAllMarketWatches(this.activeMarketWatch.getValue(), relationCode);
        } else {
          this.handleUpdateFailure(currentFavsBackup);
        }
      },
      error: (error) => {
        this.toastr.error(
          this._translate.instant("update-failed"),
          this._translate.instant("error"),
          {
            positionClass: "toast-bottom-right",
            closeButton: false,
            titleClass: "toast-error-title",
            messageClass: "toast-error-message",
          }
        );
        // Rollback to original state
        this.favCompaniesSymbols.next(currentFavsBackup);
      }
    });
}

private handleUpdateFailure(backupFavs: any[]): void {
  this.toastr.warning(
    this._translate.instant("exceed-watch-limit"),
    this._translate.instant("exceed-watch-title"),
    {
      positionClass: "toast-bottom-right",
      closeButton: false,
      titleClass: "toast-error-title",
      messageClass: "toast-error-message",
    }
  );
  
  // Restore to backup state instead of just removing last item
  this.favCompaniesSymbols.next(backupFavs);
}

getAllMarketWatches() {
  this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
  if(!this.accList || this.accList.length === 0) {
    return;
  }
  const relationCode = this.accList?.[0]?.relationCode ?? '';

  this.http
    .get<any[]>(`${UrlConstants.backofficeUrl}/api/Client/GetMarketWatchListNew?relationCode=${relationCode}`)
    .subscribe((marketWatches) => {
       
      this.marketWatches.next(marketWatches);
      
      const defaultWatch = marketWatches.find((watch) => watch?.IsDefault) || marketWatches[0];     
      this.fetchFavs(defaultWatch).subscribe({
        next: () => {

      this.setActiveMarketWatch(defaultWatch);
          // Handle successful fetch
        },
        error: (err) => {
        }
      });
    });
}
fetchAllMarketWatches(marketWatch: any, relationCode ?: string ) {
   
    // const RelationCode = relationCode ?? this.accList?.[0]?.relationCode ;

      this.http
      .get<any[]>(
        `${UrlConstants.backofficeUrl}/api/Client/GetMarketWatchListNew?relationCode=${relationCode}`,
        {
          headers: new HttpHeaders({
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          }),
        }
      )
      .subscribe(
        (marketWatches) => {
          if (marketWatches) {
            this.AllMarketWatchesCount = marketWatches.length;
            this.marketWatches.next(marketWatches);
            const defaultWatch = marketWatches.find((watch) => watch.IsDefault) || marketWatches[0];
            if (defaultWatch) this.setActiveMarketWatch(defaultWatch);
            this.fetchFavs(defaultWatch).subscribe({
              next: () => {
              },
              error: (err) => {
              }
            });
          }
        }
      );
  }

setActiveMarketWatch(marketWatch: any) {
    this.selectedMarketWatchId = marketWatch?.MarketWatchID;
    this.activeMarketWatch.next(marketWatch);
    this.favCompaniesSymbols.next(marketWatch?.symbols);  
    this.fetchFavoritesData();    
  }
fetchFavs(marketWatch: any): Observable<void> {  
  this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
  const relationCode = this.accList?.[0]?.relationCode ?? '';
  const MarketWatchID = marketWatch?.MarketWatchID ?? 0;
  
  if (MarketWatchID == null || MarketWatchID == undefined) {
    this.fetchAllMarketWatches(0,relationCode);
  }

  
  if (!this.accList || !relationCode) {
    return of(void 0); // Return empty Observable
  }

  return this.http
    .get<any[]>(
      `${UrlConstants.backofficeUrl}/api/Client/GetClientMarketWatchSymbols?MarketWatchID=${MarketWatchID}&relationCode=${relationCode}`,
      {
        headers: new HttpHeaders({
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        }),
      }
    )
    .pipe(
      tap((response) => {
        this.favCompanies.next(response);
        if (response && response.length > 0) {
          const favCodes = response.map(res => res);
          this.favCompaniesSymbols.next([]);
          this.favCompaniesSymbols.next(favCodes);
          this.fetchFavoritesData();
        }
      }),
      map(() => void 0) // Transform to void
    );
}

fetchFavoritesData() {
  const symbols = this.favCompaniesSymbols.getValue();
  if (symbols != null) {
    this.http
      .post<CompanyList[]>(`${UrlConstants.feedUrl.trim()}/api/Feed/GetMarketWatchForSymbolList`, symbols)
      .subscribe({
        next: (response) => this.favCompanies.next(response),
        error: (error) => {
          // Optionally show a user-friendly message
        }
      });
  }
}
getMarketWatchList(relationCode: string): Observable<any[]> {
  return this.http.get<any[]>(
    `${UrlConstants.backofficeUrl}/api/Client/GetMarketWatchListNew?relationCode=${relationCode}`
  );
}

getMarketWatchSymbols(marketWatchId: number, relationCode: string): Observable<string[]> {
  return this.http.get<string[]>(
    `${UrlConstants.backofficeUrl}/api/Client/GetClientMarketWatchSymbols?MarketWatchID=${marketWatchId}&relationCode=${relationCode}`
  );
}
}
